import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';

function NotFound() {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="50vh"
            gap={2}
        >
            <Typography variant="h1" sx={{ fontSize: '4rem', fontWeight: 700, color: 'text.secondary' }}>
                404
            </Typography>
            <Typography variant="h6" color="text.secondary">
                Page not found
            </Typography>
            <Button
                component={Link}
                to="/"
                variant="contained"
                startIcon={<HomeIcon />}
                sx={{ mt: 2 }}
            >
                Go to Home
            </Button>
        </Box>
    );
}

export default NotFound;
